import Calculator from '../app/calculator';

export default {
    init() {
        // JavaScript to be fired on the about us page
        const calculator = new Calculator('form#calculator');

        jQuery('.currency-switch').on('click', (event) => {
            event.preventDefault();
            calculator.switchCurrency();
        });
        jQuery('#calculator-share').on('click', (event) => {
            event.preventDefault();
            window.CC_Modals.run('calculator-share', {
                details: calculator.form.serialize(),
            });
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/Calculator.js